

export enum PlaylistThumbLinkType {
    playlistPage = "playlist-page",
    mediaPage = "media-page"
}
